var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    { staticClass: "rowBackgroundHomepage", class: _vm.customPageClass },
    [
      _c(
        "b-container",
        { class: { customContainer: !_vm.noReduce }, attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "p-0",
                  attrs: {
                    md: _vm.colWidth,
                    "offset-md": (12 - _vm.colWidth) / 2,
                  },
                },
                [
                  _c(
                    "main",
                    {
                      staticClass: "panel21 panel-default",
                      attrs: { id: _vm.mainContentId, role: "main" },
                    },
                    [
                      _c(
                        "header",
                        {
                          staticClass:
                            "panel-heading mb-0 mt-0 bg-white border border-bottom shadow-sm mx-n4 px-4",
                        },
                        [
                          _c(
                            "b-row",
                            {
                              staticClass: "align-items-center gx-4 mt-3 pb-3",
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "pe-3",
                                  attrs: {
                                    cols: "12",
                                    md: "6",
                                    lg: "7",
                                    xl: "8",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-block d-md-none text-center",
                                    },
                                    [
                                      _c(
                                        "h1",
                                        { staticClass: "panel-title mb-0" },
                                        [
                                          _vm._t("titleContent", function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "fs-24px" },
                                                [_vm._v(_vm._s(_vm.title))]
                                              ),
                                            ]
                                          }),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.mandatoryIndication
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "italicMandatoryIndication",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.asterisk_obligation_label"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-none d-md-block text-start",
                                    },
                                    [
                                      _c(
                                        "h1",
                                        { staticClass: "panel-title mb-0" },
                                        [
                                          _vm._t("titleContent", function () {
                                            return [
                                              _c(
                                                "span",
                                                { staticClass: "fs-24px" },
                                                [_vm._v(_vm._s(_vm.title))]
                                              ),
                                            ]
                                          }),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.mandatoryIndication
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "italicMandatoryIndication",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.asterisk_obligation_label"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.$slots.primaryActions
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "mt-3 mt-md-0",
                                      attrs: {
                                        cols: "12",
                                        md: "6",
                                        lg: "5",
                                        xl: "4",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-block d-md-none" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "d-flex flex-column",
                                            },
                                            [_vm._t("primaryActions")],
                                            2
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "d-none d-md-block" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-end",
                                            },
                                            [_vm._t("primaryActions")],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$slots.navigationTabs
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "bg-white border border-top-0 border-bottom py-3 mb-0 mx-n4",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "px-4" },
                                [_vm._t("navigationTabs")],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$slots.secondaryActions ||
                      _vm.showFilter ||
                      _vm.showRefresh ||
                      _vm.showExtract
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "bg-light border border-top-0 border-bottom py-3 mb-0 mx-n4 shadow-sm",
                            },
                            [
                              _c("div", { staticClass: "px-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "secondary-actions-container",
                                    staticStyle: {
                                      display: "flex !important",
                                      "flex-wrap": "wrap !important",
                                      gap: "0.5rem !important",
                                      width: "100% !important",
                                    },
                                  },
                                  [
                                    _vm.showFilter
                                      ? _c("app-button", {
                                          attrs: {
                                            text: _vm.filterExpanded
                                              ? _vm.$t("filter.hide_fltr")
                                              : _vm.$t("filter.fltr"),
                                            icon: _vm.filterExpanded
                                              ? "fa-light fa-minus"
                                              : "fa-light fa-plus",
                                            variant: "light",
                                            "responsive-layout": true,
                                            "aria-expanded": _vm.filterExpanded,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit("toggle-filter")
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showRefresh
                                      ? _c("app-button", {
                                          attrs: {
                                            text: _vm.$t("common.rfrsh"),
                                            icon: "fa-light fa-rotate-right",
                                            variant: "light",
                                            "responsive-layout": true,
                                            disabled: _vm.refreshDisabled,
                                            "aria-label":
                                              _vm.$t("common.rfrsh"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit("refresh")
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showExtract
                                      ? _c("app-button", {
                                          attrs: {
                                            text:
                                              _vm.extractText ||
                                              _vm.$t("common.extract"),
                                            icon: "fa-light fa-download",
                                            variant: "light",
                                            "responsive-layout": true,
                                            disabled: _vm.extractDisabled,
                                            "aria-label":
                                              _vm.extractText ||
                                              _vm.$t("common.extract"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit("extract")
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t("secondaryActions"),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.filterExpanded && _vm.$slots.filterContent
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "filter-content-section tw-w-full tw-mt-4 tw-pt-4 tw-border-t tw-border-gray-300 tw-block tw-clear-both",
                                      staticStyle: {
                                        display: "block !important",
                                        clear: "both !important",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "px-4" },
                                        [_vm._t("filterContent")],
                                        2
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white border-left border-right border-bottom mx-n4 px-4 py-4",
                        },
                        [_vm._t("pageContent")],
                        2
                      ),
                      _vm._v(" "),
                      _vm.$slots.bottomActions
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "bg-light border border-top-0 mt-0 mx-n4 px-4 py-4",
                              staticStyle: { "margin-bottom": "-25px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-end flex-wrap",
                                },
                                [_vm._t("bottomActions")],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("underPanel"),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._t("footerButtons"),
          _vm._v(" "),
          _c(
            "footer",
            {
              staticClass: "pb-10px mb-4",
              attrs: { "aria-label": "Informations de bas de page principale" },
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      attrs: {
                        md: _vm.colWidth,
                        "offset-md": (12 - _vm.colWidth) / 2,
                      },
                    },
                    [
                      _c("div", { staticClass: "text-center footer-stacked" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-inline-flex align-items-center justify-content-center flex-wrap mb-2",
                          },
                          [
                            _c("img", {
                              staticClass: "logoStreammind",
                              attrs: {
                                alt: "Streammind",
                                src: _vm.logoStreammind,
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-1" }, [
                              _vm._v(_vm._s(_vm.$t("common.copyright"))),
                            ]),
                            _vm._v(" \n              "),
                            _c("span", [_vm._v(_vm._s(_vm.version))]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-center flex-wrap",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-decoration-underline text-muted d-inline-block mx-2",
                                staticStyle: {
                                  "font-size": "11px",
                                  "white-space": "nowrap",
                                },
                                attrs: {
                                  href: "/sitemap",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("footer.sitemap")) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-decoration-underline text-muted d-inline-block mx-2",
                                staticStyle: {
                                  "font-size": "11px",
                                  "white-space": "nowrap",
                                },
                                attrs: {
                                  href: "/accessibilite",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.accessibilityText) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "position-relative text-center footer-inline",
                          staticStyle: { "min-height": "1.5rem" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-left",
                              staticStyle: {
                                position: "absolute",
                                left: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-decoration-underline d-inline-block",
                                  staticStyle: {
                                    "font-size": "12px",
                                    "white-space": "nowrap",
                                    color: "#000",
                                  },
                                  attrs: {
                                    href: "/sitemap",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("footer.sitemap")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-inline-flex align-items-center justify-content-center flex-wrap",
                            },
                            [
                              _c("img", {
                                staticClass: "logoStreammind",
                                attrs: {
                                  alt: "Streammind",
                                  src: _vm.logoStreammind,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(_vm._s(_vm.$t("common.copyright"))),
                              ]),
                              _vm._v(" \n              "),
                              _c("span", [_vm._v(_vm._s(_vm.version))]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "text-right",
                              staticStyle: {
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-decoration-underline d-inline-block",
                                  staticStyle: {
                                    "font-size": "12px",
                                    "white-space": "nowrap",
                                    color: "#000",
                                  },
                                  attrs: {
                                    href: "/accessibilite",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.accessibilityText) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }